import { Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import InputField from 'src/components/ui-components/InputField'
import SelectField from 'src/components/ui-components/SelectField'
import FormEncoded from './FormEncoded'

function RequestBody({ value, contentTypeMaster, requestBodyDataTypeMaster, formRef, setIsQueryTabDisabled, isLoading }) {

  const [isContentTypeRaw, setIsContentTypeRaw] = useState(false)
  const [selectedContentType, setSelectedContentType] = useState(null)

  useEffect(() => {
    if (formRef?.current?.values?.isEdit ){
      const contentType = contentTypeMaster?.find(x => x.contentTypeKey === formRef?.current?.values?.contentTypeKey)?.contentType
      if(contentType==='raw'){
        setIsContentTypeRaw(true)
      } else if (contentType==='uri'){
        setIsQueryTabDisabled(false);
      }
      else {
        setIsContentTypeRaw(false)
        setIsQueryTabDisabled(true)
        setSelectedContentType(contentType)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formRef?.current?.values?.contentTypeKey, contentTypeMaster, requestBodyDataTypeMaster]);

  const handleContentTypeChange = (newValue) => {
    const contentType = contentTypeMaster?.find(x => x.contentTypeKey === newValue?.contentTypeKey)?.contentType;
  
    formRef?.current?.setFieldValue('contentTypeKey', newValue?.contentTypeKey);
    setSelectedContentType(contentType);
  
    const clearURLQueryParams = (url) => {
      const urlWithoutQueryParams = url.split('?')[0];
      return urlWithoutQueryParams;
    }
  
    if (contentType !== "uri") {
      setIsQueryTabDisabled(true);
      if (contentType !== "raw") {
        formRef?.current?.setFieldValue('requestBody', '');
        formRef?.current?.setFieldValue('requestBodyDataTypeKey', null);
        setIsContentTypeRaw(false);
        formRef?.current?.setFieldValue('webMethodsRequestParams', [{
          parameterKey: null,
          parameterValue: null
        }]);
        const currentURL = formRef?.current?.values?.webMethodURL;
        if (currentURL) {
          const newURL = clearURLQueryParams(currentURL);
          formRef?.current?.setFieldValue('webMethodURL', newURL);
        }
      } else {
        const currentURL = formRef?.current?.values.webMethodURL;
        if (currentURL) {
          const newURL = clearURLQueryParams(currentURL);
          formRef?.current?.setFieldValue('webMethodURL', newURL);
        }
        setIsContentTypeRaw(true);
      }
    } else {
      formRef?.current?.setFieldValue('requestBody', '');
      formRef?.current?.setFieldValue('requestBodyDataTypeKey', null);
      formRef?.current?.setFieldValue('webMethodsRequestParams', [{
        parameterKey: null,
        parameterValue: null
      }]);
      setIsContentTypeRaw(false);
      setIsQueryTabDisabled(false);
    }
  
    if (contentType === "none") {
      setIsQueryTabDisabled(true);
      setIsContentTypeRaw(false);
      setSelectedContentType(contentType);
      formRef?.current?.setFieldValue('requestBody', '');
      formRef?.current?.setFieldValue('requestBodyDataTypeKey', null);
      formRef?.current?.setFieldValue('webMethodsRequestParams', [{
        parameterKey: null,
        parameterValue: null
      }]);
      const currentURL = formRef?.current?.values?.webMethodURL;
      if (currentURL) {
        const newURL = clearURLQueryParams(currentURL);
        formRef?.current?.setFieldValue('webMethodURL', newURL);
      }
    }
  }
  
  return (
    <>
      {value === 0 && (
        <Grid spacing={2} container sx={{ paddingTop: '20px' }}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <SelectField label="Content Type *" name="contentTypeKey" data={contentTypeMaster} dataTextField="contentType" dataValueField="contentTypeKey" onChange={handleContentTypeChange} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <SelectField label={`Request Body Data Type${isContentTypeRaw ? ' *' : ''}`} name="requestBodyDataTypeKey" data={requestBodyDataTypeMaster} dataTextField="requestBodyDataType" dataValueField="requestBodyTypeKey" disable={!isContentTypeRaw} />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {selectedContentType && selectedContentType === "x-www-form-urlencoded" ?
              <FormEncoded formRef={formRef} isLoading={isLoading} /> :
              <InputField label={`Request Body${isContentTypeRaw ? ' *' : ''}`} name="requestBody" multiline rows={5} disabled={!isContentTypeRaw} />
            }
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default RequestBody;
